import PropTypes from 'prop-types';

const EvStation = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  nrelId: PropTypes.number,
  stationName: PropTypes.string,
  streetAddress: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
  country: PropTypes.string,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  distanceMiles: PropTypes.number,

  // Status & Access
  statusCode: PropTypes.string,
  accessCode: PropTypes.string,
  accessDaysTime: PropTypes.string,
  stationPhone: PropTypes.string,
  facilityType: PropTypes.string,

  // Network
  evNetwork: PropTypes.string,
  evNetworkWeb: PropTypes.string,

  // Charging Infrastructure
  evLevel1EvseNum: PropTypes.number,
  evLevel2EvseNum: PropTypes.number,
  evDcFastNum: PropTypes.number,

  // Pricing
  evPricing: PropTypes.string,

  // Connector Details
  evJ1772ConnectorCount: PropTypes.number,
  evJ1772PowerOutput: PropTypes.number,
  evCcsConnectorCount: PropTypes.number,
  evCcsPowerOutput: PropTypes.number,
  evChademoConnectorCount: PropTypes.number,
  evChademoPowerOutput: PropTypes.number,
  evJ3400ConnectorCount: PropTypes.number,
  evJ3400PowerOutput: PropTypes.number,

  // Additional
  evWorkplaceCharging: PropTypes.bool,
  cardsAccepted: PropTypes.string,
  maximumVehicleClass: PropTypes.string,
  openDate: PropTypes.string,
  dateLastConfirmed: PropTypes.string,
});

export const EvNetwork = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  networkKey: PropTypes.string,
  name: PropTypes.string,
  nameFr: PropTypes.string,
  url: PropTypes.string,
});

export const EvConnectorType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  code: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  isDc: PropTypes.bool,
});

export default EvStation;
